import { vservice } from '@niknevis/vue-modules'
import { AdminVipGroupRoute } from '@/modules/vip-group/routes/admin-vip-group.route'
import { Inertia } from '@/modules/shared/helpers/http/facades/inertia'
import { VipGroupRequestModel } from '@/modules/vip-group/models/vip-group-request.model'
import Dialog from 'quasar/src/plugins/Dialog.js';
import DeleteConfirm from '@/modules/common/dialog/components/shared/DeleteConfirm.vue'

@vservice()
export class AdminVipGroupService {
  constructor(
    private readonly routes: AdminVipGroupRoute
  ) {
  }

  store(data: VipGroupRequestModel) {
    return Inertia.post(
      this.routes.store(),
      data
    )
  }

  update(id: number, data: VipGroupRequestModel) {
    return Inertia.put(
      this.routes.update(id),
      data,
      { preserveScroll: true }
    )
  }

  destroy(id: number) {
    return Inertia.delete(
      this.routes.destroy(id)
    ).onBeforeAsync(() => new Promise<boolean>((resolve) => {
      Dialog.create({
        component: DeleteConfirm,
        title: 'حذف گروه',
        message: 'آیا از حذف گروه اطمینان دارید ؟'
      }).onOk(() => resolve(true))
        .onCancel(() => resolve(false))
        .onDismiss(() => resolve(false))
    }))
  }

}